var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "log-out",
    transform: "translate(-2.15 -2.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2702",
    "data-name": "Group 2702",
    transform: "translate(2.15 2.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2035",
    "data-name": "Path 2035",
    d: "M7.713,18.15H4.465A2.317,2.317,0,0,1,2.15,15.835V4.465A2.317,2.317,0,0,1,4.465,2.15H7.713a.69.69,0,1,1,0,1.381H4.465a.935.935,0,0,0-.934.934V15.835a.935.935,0,0,0,.934.934H7.713a.69.69,0,1,1,0,1.381Z",
    transform: "translate(-2.15 -2.15)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2036",
    "data-name": "Path 2036",
    d: "M15.84,15.653a.69.69,0,0,1-.488-1.179L18.925,10.9,15.352,7.329a.69.69,0,0,1,.976-.976l4.061,4.061a.69.69,0,0,1,0,.976L16.329,15.45A.688.688,0,0,1,15.84,15.653Z",
    transform: "translate(-4.592 -2.901)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2037",
    "data-name": "Path 2037",
    d: "M18.587,12.531H8.84a.69.69,0,1,1,0-1.381h9.746a.69.69,0,0,1,0,1.381Z",
    transform: "translate(-3.277 -3.84)",
    fill: "#212121"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/logOut.bee634abaf4521bf72fbb93c6b9ab882.svg";
export { ForwardRef as ReactComponent };